import { PlanoPagamentoParcela } from 'src/tipos'

export enum TiposPrecificacao {
  Precificacao = 'Precificacao',
  Campanha = 'Campanha'
}

export enum TiposPrecificacaoPorExtenso {
  Precificacao = 'Precificação',
  Campanha = 'Campanha'
}

export enum PrecificacaoCategoria {
  Base = 'Base',
  Cpf = 'Cpf',
  CampanhaPos = 'CampanhaPos',
  CampanhaExtensao = 'CampanhaExtensao'
}

export enum PrecificacaoCategoriaPorExtenso {
  Base = 'Precificação Base',
  Cpf = 'Precificação por CPF',
  CampanhaPos = 'Campanha Pós-graduação',
  CampanhaExtensao = 'Campanha Extensão'
}

export interface PrecificacaoItem {
  id?: string
  nome: string
  codigo: string
  cpf?: string
  dataInicio: Date
  dataFim: Date
  tipo: TiposPrecificacao
  categoria: PrecificacaoCategoria
  valorBase?: boolean
  pctDesconto?: number
  planosPagamento?: PlanoPagamentoParcela[]
  cursoId?: Array<string>
  precificacaoBase?: boolean
  ativo?: boolean
}

export interface BaseAtivaCurso {
  existe: boolean
  precificacaoId?: string
  precificacaoNome?: string
}

export interface Precificacao {
  itens: Array<PrecificacaoItem>
  quantidade: number
  opcoesPaginacao: {
    pagina: number
    totalRegistros: number
  }
}
